import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import useTranslationSetup from "../../utils/useTranslationSetup";
import shortRecordingImg from "../../assets/short_recording.svg";
import "./styles.css";

const AudioSizeShortError = ({
  isDialogOpen,
  warningHeading,
  warningMessage,
  onClickRetakeButton,
}) => {
  const { t, activeLanguage } = useTranslationSetup();

  return (
    <Dialog className="custom-dialog" open={isDialogOpen}>
      <DialogTitle className="audio-size-short-error-title">
        <img src={shortRecordingImg} alt="Short" />
      </DialogTitle>

      <DialogContent>
        <Box>
          <Typography
            textAlign="center"
            fontSize="20px"
            className="custom-ff-regular"
            lang={activeLanguage}
          >
            {warningHeading}
          </Typography>
          <Typography
            textAlign="center"
            fontSize="14px"
            color="black.hot"
            margin="8px 0 30px"
            padding="0px 6px"
            lang={activeLanguage}
            className="custom-ff-regular"
          >
            {warningMessage}
          </Typography>

          <Box
            style={{
              display: "flex",
              width: "100%",
            }}
          >
            <Button
              className="custom-ff-regular audio-size-short-error-retake-button btn-primary"
              variant="contained"
              onClick={onClickRetakeButton}
              disableElevation
              lang={activeLanguage}
            >
              {t("retake")}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AudioSizeShortError;
